module.exports = __webpack_public_path__ + "img/logbooks-1.12fff0f4.gif";